import { Flex, Loader, Square } from '@grubhubprod/gh-cookbook-react';
import React from 'react';

export function SectionLoader(): JSX.Element {
  return (
    <Square inset="lg" bg="globals.white" dimension="2" height="276px">
      <Flex alignItems="center" justifyContent="center" height="100%">
        <Loader size="sm" />
      </Flex>
    </Square>
  );
}
